//#region Icons
import PersonIcon from "icons/PersonIcon";
import AtIcon from "icons/AtIcon";
import OpenEyeIcon from "icons/OpenEyeIcon";
import BriefcaseIcon from "icons/BriefcaseIcon";
import SmileIcon from "icons/SmileIcon";
import CalendarIcon from "icons/CalendarIcon";
import TimerIcon from "icons/TimerIcon";
//#endregion

export const HEADERS_TABLE_LIST = [
    {
        title: "Usuario", 
        icon: <AtIcon/>
    },
    {
        title: "Nombres", 
        icon: <PersonIcon/>
    },
    {
        title: "Apellidos", 
        icon: <SmileIcon/>
    },
    {
        title: "Categoría", 
        icon: <OpenEyeIcon/>
    },
    {
        title: "Rol", 
        icon: <BriefcaseIcon/>
    },
    {
        title: "Fecha", 
        icon: <CalendarIcon/>
    },
    {
        title: "Hora", 
        icon: <TimerIcon/>
    }
];
export const SAMPLE_CHANGE_HISTORY = [
    {
        field: "Nombre",
        before: "Fiorella",
        now: "Fio",
        date: "01/10/2022",
        time: "10:00"
    },
    {
        field: "Rol",
        before: "Superadmin",
        now: "Admin",
        date: "15/10/2022",
        time: "13:00"
    }
];